export const SHOW_MORE_RESULTS_KEY = 'show-more-results';
export const SHOW_MORE_ROW_HEIGHT = 56;
export const ADVANCED_SEARCH_ITEM_KEY = 'advanced-search-item';
export const ADVANCED_AI_SEARCH_ITEM_KEY = 'advanced-ai-search-item';
